module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-ts-config/gatsby-browser.js'),
      options: {"plugins":[],"configDir":"/home/vsts/work/1/s/src/gatsby","projectRoot":"/home/vsts/work/1/s","babel":false,"tsNode":true},
    }]
